import React, { useState, useRef, useEffect, useCallback } from "react";
import '../../Complaint.css';
import { useForm } from "react-hook-form";
import { FaDownload, FaSearch, FaSpinner, FaMinusSquare, FaPlusSquare, FaSyncAlt, FaCheckCircle, FaToggleOn, FaToggleOff, FaPen, FaTrash, FaTimesCircle, FaComments } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import toast from "react-hot-toast";
import { API_DOMAIN, FileIcons, TYPE_Of_CASE, allowedTypes } from "../../Common/CommonVariables";
import * as ComplaintService from '../../Services/Complaint/ComplaintService'
import * as moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent";

import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom';
import { Calendar } from "lucide-react";
import "./ComplaintListComponent.css"


const ComplaintListComponent = () => {
  const [complaintTypeShow, setComplaintTypeShow] = useState(false);
  const [newComplaintShow, setNewComplaintShow] = useState(false);
  const [activeTab, setActiveTab] = useState("caseDetails");
  const [selectedComplaintType, setSelectedComplaintType] = useState(null);
  const [SelectedComplaintTypeID, setSelectedComplaintTypeID] = useState(null);

  const [filteredComplaintList, setFilteredComplaintList] = useState([]);

  const { register, handleSubmit, getValues, setValue, setError, clearErrors, formState: { errors }, reset, trigger, } = useForm();
  const { handleSubmit: handleEditCaseSubmit, register: registerEditCase, setValue: setValueEditCase, reset: resetEditCase, formState: { errors: errorEditCase }, } = useForm();

  const [caseDetailModal, setCaseDetailModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState({});

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [SearchLoading, setSearchLoading] = useState(false);
  const selectedSearchCN = useRef();

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Set number of items per page

  // Pagination logic
  const indexOfLastComplaint = currentPage * itemsPerPage;
  const indexOfFirstComplaint = indexOfLastComplaint - itemsPerPage;
  const currentComplaints = filteredComplaintList.slice(indexOfFirstComplaint, indexOfLastComplaint);


  //Edit Case Details
  //Tab1
  const [caseViewActiveTab, setCaseViewActiveTab] = useState("caseDetails");
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [caseAttachmentDetails, setcaseAttachmentDetails] = useState(null); //Tab2
  const [caseCommentDetails, setcaseCommentDetails] = useState(null); //Tab3
  const [caseHistoryDetails, setcaseHistoryDetails] = useState(null); // Tab 4

  const navigate = useNavigate();

  const [expandedSections, setExpandedSections] = useState({
    caseDetails: true,
    customerDetails: true,
    status: true,
    actionTaken: true,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  // New Complaint/Case 
  const [CaseOriginDetailList, setCaseOriginDetailList] = useState([]);
  const [CaseTypeDetailList, setCaseTypeDetailList] = useState([]);
  const [CaseRecordTypeDetialList, setCaseRecordTypeDetialList] = useState([]);
  const [CaseCategoryDetailsList, setCaseCategoryDetailsList] = useState([]);
  const [CaseLocationDetailsList, setCaseLocationDetailsList] = useState([]);
  const [CaseStageDetailsList, setCaseStageDetailsList] = useState([]);
  const [CaseSRTypeDetailsList, setCaseSRTypeDetailsList] = useState([]);
  const [CountryDetailList, setCountryDetailList] = useState([]);
  const [ActivePaymentModeList, setActivePaymentModeList] = useState([]);
  const [CaseSRSubTypeDetailsList, setCaseSRSubTypeDetailsList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [PatientVisitIdList, setPatientVisitIdList] = useState([]);
  const [ShowPatientVisitIdList, setShowPatientVisitIdList] = useState(false);

  // const data = {
  //   Data: Array.from({ length: 5000 }, (_, i) => ({
  //     CaseNumber: `CASE-${1000 + i}`,
  //     MHL_Call_Type__c: `Call Type ${i + 1}`,
  //     Status: i % 2 === 0 ? "Open" : "Closed",
  //     Subject: `Subject ${i + 1}`,
  //     MHL_Department__c: `Department ${i % 5 + 1}`
  //   }))
  // };

  const formatDateToUTC = (date) => {
    const d = new Date(date);
    return d.toISOString().split('T')[0] + 'T00:00:00Z';
  };
  const formatDateTimeToUTC = (date) => {
    const d = new Date(date);
    return d.toISOString(); // full ISO string including time
  };

  const validateDateRange = (startDateValue, endDateValue) => {
    if (!startDateValue || !endDateValue) {
      toast.error("Please select a date range");
      return false;
    }
    if (startDateValue > endDateValue) {
      toast.error("Start date cannot be after end date");
      return false;
    }
    if (endDateValue > new Date()) {
      toast.error("End date cannot be in the future");
      return false;
    }
    return true;
  };

  const buildRequestData = (startDateValue, endDateValue) => ({
    StartDate: new Date(new Date(startDateValue).setHours(0, 0, 0, 0)).toISOString(),
    EndDate: new Date(new Date(endDateValue).setHours(23, 59, 59, 999)).toISOString(),
  });

  const fetchComplaints = () => {
    setFilteredComplaintList([]);
    if (!validateDateRange(startDate, endDate)) return;

    const requestData = buildRequestData(startDate, endDate);

    setSearchLoading(true);
    setLoading(true);

    ComplaintService.CaseList_Filter(requestData)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setFilteredComplaintList(data.Data);
        } else {
          setFilteredComplaintList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => {
        setLoading(false);
        setSearchLoading(false);
      });
  };


  // const fetchComplaints = useCallback(() => {
  //   //debugger;
  //   if (startDate == null || endDate == null) {
  //     toast.error("Please select a date range");
  //     return;
  //   }
  //   if (startDate > endDate) {
  //     toast.error("Start date cannot be after end date");
  //     return;
  //   }
  //   if (endDate > new Date()) {
  //     toast.error("End date cannot be of future");
  //     return;
  //   }

  //   //debugger;
  //   setSearchLoading(true);
  //   setLoading(true);

  //   const requestData = {
  //     StartDate: startDate
  //       ? new Date(new Date(startDate).setHours(0, 0, 0, 0)).toISOString()
  //       : null,
  //     EndDate: endDate
  //       ? new Date(new Date(endDate).setHours(23, 59, 59, 999)).toISOString()
  //       : null,
  //   };

  //   ComplaintService.CaseList_Filter(requestData)
  //     .then(({ data }) => {
  //       if (data.IsSuccess) {
  //         setFilteredComplaintList(data.Data);
  //       }
  //       else (
  //         setFilteredComplaintList([])
  //       )
  //     })
  //     .catch(() => toast.error("Something went wrong."))
  //     .finally(() => { setLoading(false); setSearchLoading(false); });
  // }, []);

  useEffect(() => {
    fetchComplaints();
  }, []);

  const fetchUniversalFilterCaseData = () => {
    //debugger;
    if (selectedSearchCN.current.value == null || selectedSearchCN.current.value == "") {
      window.location.reload();
      return;
    }
    setLoading(true);
    ComplaintService.GetUniversalFilterCaseData(selectedSearchCN.current.value)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setFilteredComplaintList(data.Data);
        }
        else (
          setFilteredComplaintList([])
        )
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const handleViewCaseDetailByNo = (caseNo) => {
    //debugger;
    setLoading(true);
    setSelectedCase({});
    setCaseLocationDetailsList([]);
    setCaseStageDetailsList([]);
    setCaseSRTypeDetailsList([]);
    setCaseSRSubTypeDetailsList([]);
    ComplaintService.GetCaseDetailByCaseNumber(caseNo).then(({ data }) => {
      if (data.IsSuccess) {
        //debugger;
        if (data.Data.CaseData.MHL_SR_Type__c == "Refund") {

        }
        setSelectedComplaintTypeID(data.Data.CaseData.RecordTypeId);
        setSelectedCase(data.Data.CaseData);
        setCaseLocationDetailsList(data.Data.CaseLocationData);
        setCaseStageDetailsList(data.Data.CaseStageData);
        setCaseSRTypeDetailsList(data.Data.CaseSRTypeData);
        setCaseSRSubTypeDetailsList(data.Data.CaseSRSubTypeData);
        setCaseCategoryDetailsList(data.Data.CaseCategoryData);
        // handlecaseeditevents(data.Data);
        setCaseDetailModal(true);
      } else {
        setSelectedCase({})
        // toast.error("No Data found for selected range");
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const handleDownloadAttachment = async (file) => {
    //debugger;

    setLoading(true);  // Start loading
    const downloadUrl = API_DOMAIN + `Case/DownaloadAttachments?url=${file.VersionData}&filename=${file.Title}&ext=${file.FileExtension}`;

    try {
      const response = await trackPromise(
        axios.get(downloadUrl, {
          headers: CommonVariables.API_HEADER,  // Add your headers here
          responseType: 'blob',                 // Important for files
        })
      );

      const blob = new Blob([response.data]);
      saveAs(blob, file.Title + '.' + file.FileExtension);
    } catch (error) {
      console.error('Download failed:', error);
    }

    setLoading(false);
  };

  const GetCaseCommentByCaseId = (caseId) => {
    ComplaintService.GetCaseCommentByCaseId(caseId).then(({ data }) => {
      if (data.IsSuccess) {
        setcaseCommentDetails(data.Data);
      }
      else {
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const GetCaseHistoryByCaseId = (caseId) => {
    setLoading(true);
    ComplaintService.GetCaseHistoryByCaseId(caseId).then(({ data }) => {
      if (data.IsSuccess) {
        //debugger;
        setcaseHistoryDetails(data.Data);
      }
      else {
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const GetAttachmentsByCaseId = (caseId) => {
    setLoading(true);
    ComplaintService.GetAttachmentsByCaseId(caseId).then(({ data }) => {
      if (data.IsSuccess) {
        setcaseAttachmentDetails(data.Data);
      } else {
        setcaseAttachmentDetails([])
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const handleComplaintTypeClose = () => {
    setSelectedComplaintType("");
    setSelectedComplaintTypeID("");
    setComplaintTypeShow(false)
  };

  const handleNewComplaintClose = () => {
    // setLoading(true)
    setShowPatientVisitIdList(false)
    setActivePaymentModeList([]);
    setSelectedComplaintType("");
    setSelectedComplaintTypeID("");
    setNewComplaintShow(false);
    setActiveTab("caseDetails");
    setShowAdditionalRefundInfo("");
    setSelectedFiles([]);
    setCaseLocationDetailsList([]);
    setCaseStageDetailsList([]);
    setCaseSRTypeDetailsList([]);
    setCaseCategoryDetailsList([]);
    setCaseSRSubTypeDetailsList([]);
    reset();
    // setLoading(false)
  };

  const handleProceed = () => {
    if (!selectedComplaintType) {
      toast.error("Please select a complaint type.");
      return;
    }
    GetCaseOriginDetailList();
    GetCaseTypeDetailList();
    GetCountryDetailList();
    setComplaintTypeShow(false);
    setNewComplaintShow(true);
  };

  const handlePrevious = () => {
    setLoading(true);
    if (activeTab === "customerDetails") {
      setActiveTab("addAttachments");
    }
    else if (activeTab === "addAttachments") {

      if (showAdditionalRefundInfo) {
        setActiveTab("additionalRefundInfo");
      } else {
        setActiveTab("caseDetails");
      }
    }
    else if (activeTab === "additionalRefundInfo") {
      setActiveTab("caseDetails");
    }
    setLoading(false);
  };

  const validateCurrentTab = async () => {
    const result = await trigger();
    return result;
  };


  const onSubmit = async (data) => {
    setLoading(true);

    if (activeTab === "caseDetails") {
      if (showAdditionalRefundInfo) {
        setActiveTab("additionalRefundInfo");
      } else {
        setActiveTab("addAttachments");
      }
      setLoading(false);
    }
    else if (activeTab === "additionalRefundInfo") {

      setActiveTab("addAttachments");
      setLoading(false);
    }
    else if (activeTab === "addAttachments") {
      if (selectedFiles.length != UploadedFileAttachmentList.length) {
        alert("Please upload selected files first.")
        setLoading(false);
        return;
      }
      setActiveTab("customerDetails");
      setLoading(false);
    }
    else {
      //debugger;
      if (selectedFiles.length != UploadedFileAttachmentList.length) {
        alert("Please upload selected files first.")
        setLoading(false);
        return;
      }

      // if (showAdditionalRefundInfo)
      //   data.MHL_VID__c = PatientVisitIdList.
      data.UploadedFileAttachmentList = UploadedFileAttachmentList;
      ComplaintService.CreateCase(data).then(({ data }) => {
        if (data.IsSuccess) {
          //debugger;
          fetchComplaints();
          setEndDate(new Date());
          // window.location.reload();
          setSelectedComplaintType("");
          setSelectedComplaintTypeID("");
          toast.success(data.Data + " - Complaint created successfully")
          handleNewComplaintClose();
          setActiveTab("caseDetails");
          // navigate('/complaint');
        } else {
          toast.error("Something went wrong.")
        }
      }).catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );

    }
  };

  const handleCloseCaseDetail = () => {
    setLoading(true);
    resetEditCase();
    setCaseViewActiveTab("caseDetails");
    setSelectedCase({});
    setCaseDetailModal(false);
    setLoading(false);
  };

  const GetCaseOriginDetailList = () => {
    ComplaintService.GetCaseOriginList().then(({ data }) => {
      if (data.IsSuccess) {
        setCaseOriginDetailList(data.Data);
      } else {
        setCaseOriginDetailList([])
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const GetCaseTypeDetailList = () => {
    ComplaintService.GetCallTypeList().then(({ data }) => {
      if (data.IsSuccess) {
        setCaseTypeDetailList(data.Data);
      } else {
        setCaseTypeDetailList([])
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const GetCaseRecordTypeList = () => {
    ComplaintService.GetCaseRecordTypeList().then(({ data }) => {
      if (data.IsSuccess) {
        setCaseRecordTypeDetialList(data.Data);
      } else {
        setCaseRecordTypeDetialList([])
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const [showAdditionalRefundInfo, setShowAdditionalRefundInfo] = useState(false);

  const handleSRTypeChange = (event) => {
    //debugger;
    setCaseSRSubTypeDetailsList([]);
    // const value = event.target.value;
    const value = event.target.options[event.target.selectedIndex].text;

    const selectedOption = event.target.selectedOptions[0]; // Get the selected option
    const caseSRTypeId = selectedOption ? selectedOption.getAttribute("data-srtypeid") : null;

    setShowAdditionalRefundInfo(value === "Refund");
    GetActivePaymentModeList();
    GetCaseSRSubTypeDetailsList(caseSRTypeId, SelectedComplaintTypeID)
  };

  const handleEditSRTypeChange = (event) => {
    //debugger;
    setLoading(true);
    setCaseSRSubTypeDetailsList([]);
    // const value = event.target.value;
    const value = event.target.options[event.target.selectedIndex].text;

    const selectedOption = event.target.selectedOptions[0]; // Get the selected option
    const caseSRTypeId = selectedOption ? selectedOption.getAttribute("data-edit-srtypeid") : null;

    setShowAdditionalRefundInfo(value === "Refund");
    GetActivePaymentModeList();
    GetCaseSRSubTypeDetailsList(caseSRTypeId, SelectedComplaintTypeID)
  };

  const handleCallTypeSetCaseRaised = (event) => {
    //debugger;
    setLoading(true);
    const selectedOption = event.target.selectedOptions[0]; // Get the selected option
    const callTypeId = selectedOption ? selectedOption.getAttribute("data-calltypeid") : null;

    if (!callTypeId)
      return;
    else {
      GetCallCategoryMappingList(callTypeId, SelectedComplaintTypeID)
    }
  };

  const GetCallCategoryMappingList = (typeId, SelectedComplaintTypeID) => {
    //debugger;
    ComplaintService.GetCallCategoryMappingList(typeId, SelectedComplaintTypeID).then(({ data }) => {
      if (data.IsSuccess) {
        setCaseCategoryDetailsList(data.Data);
      } else {
        setCaseCategoryDetailsList([])
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const handleDependedTagsofCaseRaised = (event) => {
    setLoading(true);
    const selectedOption = event.target.selectedOptions[0];
    const raisedId = selectedOption ? selectedOption.getAttribute("data-casecategoryid") : null;

    setShowAdditionalRefundInfo("")
    setCaseLocationDetailsList([]);
    setCaseStageDetailsList([]);
    setCaseSRTypeDetailsList([]);
    setCaseSRSubTypeDetailsList([]);

    if (!raisedId)
      return
    else {
      GetCaseStageDetailsList(raisedId, SelectedComplaintTypeID)
      GetCaseSRTypeDetailsList(raisedId, SelectedComplaintTypeID)
      GetCaseLocationDetailsList(raisedId, SelectedComplaintTypeID)
    }
  };

  const handleEditDependedTagsofCaseRaised = (event) => {

    const selectedOption = event.target.selectedOptions[0];
    const raisedId = selectedOption ? selectedOption.getAttribute("data-edit-casecategoryid") : null;
    setShowAdditionalRefundInfo("")
    setCaseLocationDetailsList([]);
    setCaseStageDetailsList([]);
    setCaseSRTypeDetailsList([]);
    setCaseSRSubTypeDetailsList([]);

    if (!raisedId)
      return
    else {
      GetCaseStageDetailsList(raisedId, SelectedComplaintTypeID)
      GetCaseSRTypeDetailsList(raisedId, SelectedComplaintTypeID)
      GetCaseLocationDetailsList(raisedId, SelectedComplaintTypeID)
    }
  };

  const GetCaseStageDetailsList = (caseCategoryId, SelectedComplaintTypeID) => {
    ComplaintService.GetCaseStageDetailsList(caseCategoryId, SelectedComplaintTypeID)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setCaseStageDetailsList(data.Data);
        } else {
          setCaseStageDetailsList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const GetCaseSRTypeDetailsList = (caseCategoryId, SelectedComplaintTypeID) => {
    ComplaintService.GetCaseSRTypeDetailsList(caseCategoryId, SelectedComplaintTypeID)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setCaseSRTypeDetailsList(data.Data);
        } else {
          setCaseSRTypeDetailsList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const GetCaseLocationDetailsList = (caseCategoryId, SelectedComplaintTypeID) => {
    ComplaintService.GetCaseLocationDetailsList(caseCategoryId, SelectedComplaintTypeID)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setCaseLocationDetailsList(data.Data);
        } else {
          setCaseLocationDetailsList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const GetCaseSRSubTypeDetailsList = (caseSRTypeId, SelectedComplaintTypeID) => {
    //debugger;
    ComplaintService.GetCaseSRSubTypeDetailsList(caseSRTypeId, SelectedComplaintTypeID)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setCaseSRSubTypeDetailsList(data.Data);
        } else {
          setCaseSRSubTypeDetailsList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const GetCountryDetailList = () => {
    ComplaintService.GetCountryDetailList()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setCountryDetailList(data.Data);
        } else {
          setCountryDetailList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const GetActivePaymentModeList = () => {
    ComplaintService.GetActivePaymentModeList()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setActivePaymentModeList(data.Data);
        } else {
          setActivePaymentModeList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const [UploadedFileAttachmentList, setUploadedFileAttachmentList] = useState([]);

  const fileInputRef = useRef(null);

  const maxFiles = 5;

  const handleFileChange = (event) => {

    const file = event.target.files;

    // if (selectedFiles.length + file.length > maxFiles) {
    //   toast.error(`You can only upload up to ${maxFiles} files.`);
    //   event.target.value = ""; // Clear selected files
    //   return;
    // }
    const maxFileSize = 5 * 1024 * 1024; // 5MB
    // const maxFiles = 5;

    // const files = Array.from(event.target.files);

    if (!file || file.length === 0) {
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      return;
    }

    if (selectedFiles.length >= maxFiles) {
      toast.error(`You can only upload up to ${maxFiles} files.`);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      return;
    }

    if (!allowedTypes.includes(file[0].type) || file[0].size > maxFileSize) {
      toast.error('File is either unsupported or exceeds the 5MB limit.');
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      return;
    }

    //debugger;
    const alreadyExists = selectedFiles.some(f => f.name === file[0].name && f.size === file[0].size);
    if (alreadyExists) {
      toast.error('This file is already selected.');
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      return;
    }
    const filesArray = Array.from(event.target.files);
    // setSelectedFiles(filesArray); // Set the selected files as an array
    setSelectedFiles(prevFiles => [...prevFiles, ...filesArray]);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const handleRemoveSelectedUploadedFiles = () => {
    //debugger;
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setSelectedFiles([])
    setUploadedFileAttachmentList([])
  }

  const handleFileUpload = () => {
    //debugger;
    setLoading(true);
    const formData = new FormData();


    const uploadedTitles = UploadedFileAttachmentList.map(file => file.Title);
    const newFilesToPush = selectedFiles.filter(file => !uploadedTitles.includes(file.name));

    newFilesToPush.forEach(file => {
      formData.append('Myfile', file)
    });

    if (newFilesToPush.length <= 0) {
      toast.error("Please select file first!")
      setLoading(false);
      return
    }
    ComplaintService.UploadCaseFileAttachment(formData)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
          // setUploadedFileAttachmentList(data.Data);
          setUploadedFileAttachmentList(prevList => [...prevList, ...data.Data]);
          toast.success(data.Data.length + " files uploaded successfully.")
        } else {
          // setUploadedFileAttachmentList([])
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const UpdateCaseDetail = (casedata) => {
    //debugger;
    setLoading(true);
    //console.log("Updating Case Detail:", casedata);

    ComplaintService.UpdateCase(casedata)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          // handleViewCaseDetailByNo(casedata.CaseNumber)
          // setEndDate(new Date());
          if (casedata.MHL_SR_Type__c == "Refund") {
            GetActivePaymentModeList();
            selectedCase.MHL_SR_Type__c = "Refund"
          }
          toast.success("Case Record Updated.")
        } else {

        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const GetPatientVisitDataList = (searchData) => {

    if (searchData.target.value.length >= 4) {
      ComplaintService.GetPatientVisitDataList(searchData.target.value)
        .then(({ data }) => {
          //debugger;
          if (data.IsSuccess) {
            // trigger("MHL_VID__c"); 
            setPatientVisitIdList(data.Data)
            setShowPatientVisitIdList(true)
          } else {
            setPatientVisitIdList([])
            setShowPatientVisitIdList(false)
            // toast.error("No data available for entered VID")
          }
        })
        .catch(() => toast.error("Something went wrong."))
        .finally(() => setLoading(false));
    }
    else {
      setShowPatientVisitIdList(false)
      // setPatientVisitIdList([])
    }
  };

  const handleSelect = (value) => {
    setShowPatientVisitIdList(false)
    setValue("MHL_VID__c", value.MHL_ExternalVID__c);
    setValue("Ref_VID", value.Id);
  };

  return (
    < >
      <LoadingSpinnerComponent></LoadingSpinnerComponent>
      <CommonContainer icon={<FaComments size={20}/>} heading="Complaint List" buttonText={
            <span className="d-inline-flex align-items-center">
              <span className="d-none d-sm-inline">Raise Complaint</span>
              {/* <span className="d-inline d-sm-none"></span> */}
            </span>
          }
           onButtonClick={() => { GetCaseRecordTypeList(); setComplaintTypeShow(true) }}>

        <div className="d-flex flex-column flex-lg-row mb-2 date-search-content gap-2">
          <div className="d-flex flex-column flex-md-row gap-2 mb-2">

            <div>
              <div className="d-flex flex-column flex-md-row gap-2" style={{whiteSpace: "nowrap"}}>
                <div className="position-relative d-flex justify-content-between align-items-center ">
                  <label className="mb-0 mr-2">Start Date:</label>
                  <ReactDatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select Start Date"
                    ref={startDateRef}
                  />
                  <Calendar
                    size={20}
                    className="position-absolute"
                    style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                    onClick={() => startDateRef.current.setFocus()}
                  />
                </div>

                <div className="position-relative d-flex justify-content-between align-items-center ">
                  <label className="mb-0 mr-2">End Date:</label>
                  <ReactDatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select End Date"
                    ref={endDateRef}
                  />
                  <Calendar
                    size={20} className="position-absolute"
                    style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                    onClick={() => endDateRef.current.setFocus()}
                  />
                </div>
              </div>
            </div>
            {/* <label>Start Date:</label>
            <ReactDatePicker
              selected={startDate}
              onChange={setStartDate}
              className="form-control"
              dateFormat="dd-MM-yyyy"
              placeholderText="Select Start Date"
            />

            <label>End Date:</label>
            <ReactDatePicker
              selected={endDate}
              onChange={setEndDate}
              className="form-control"
              dateFormat="dd-MM-yyyy"
              placeholderText="Select End Date"
            /> */}

            <button
              className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-btn"
              style={{ height: "35px", padding: "0" }}
              onClick={fetchComplaints}
              disabled={loading}
            >
              {/* <FaSearch /> */}
              {SearchLoading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
            </button>
            <button
              className="btn btn-danger d-flex align-items-center justify-content-center refresh-btn"
              style={{ height: "35px", padding: "0" }}
              onClick={() => window.location.reload()}
            >
              <FaSyncAlt />
            </button>
            {SearchLoading ? 
            <CommonVariables.LoadingMessage/> 
            : null}
          </div>




          <div className="search-box" style={{ position: "relative", }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              ref={selectedSearchCN}
              style={{
                paddingRight: "35px",
                borderRadius: "5px",
                border: "1px solid #ddd",
              }}
            />
            <button
              className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-box-btn"
              style={{
                padding: '5px',
                position: "absolute",
                right: "0px",
                height: "35px",
                width: "45px",
                top: "50%",
                borderTopLeftRadius: "0",
                borderBottomLeftRadius: "0",
                transform: "translateY(-50%)"
              }}
              onClick={fetchUniversalFilterCaseData}
              disabled={loading}
            >
              <FaSearch />
            </button>

          </div>
        </div>
        <div className="mt-3 mt-lg-2">
          <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "680px" }}>
            <table className="table table-bordered custom-table" >
              <thead>
                <tr>
                  <th style={{ width: "7%" }}> Case No </th>
                  <th style={{ width: "10%" }}> Created </th>
                  <th style={{ width: "8%" }}> Name </th>
                  <th style={{ width: "10%" }}> Record Type </th>
                  <th style={{ width: "8%" }}> SR Type </th>
                  <th style={{ width: "10%" }}> SR Sub Type </th>
                  <th style={{ width: "5%" }}> Status </th>
                  <th style={{ width: "15%" }}> Subject </th>
                  <th style={{ width: "10%" }}> Department </th>
                  <th style={{ width: "10%" }}> Owner </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "10px" }}>
                {
                  currentComplaints.length > 0 ? (
                    currentComplaints.map((rec, index) => (
                      <tr key={index} >
                        <td>
                          {
                            rec.RecordType.Name === 'FTR' ? (
                              rec.CaseNumber
                            ) : (
                              <span title="Click to view details" onClick={() => handleViewCaseDetailByNo(rec.CaseNumber)} className="text-primary" style={{ cursor: "pointer" }}> {rec.CaseNumber} </span>
                            )
                          }
                        </td >
                        <td> {moment(rec.CreatedDate).format("DD-MMM-YYYY hh:mm A")} </td>
                        <td> {rec.MHL_Customer_Name__c} </td>
                        <td> {rec.RecordType.Name} </td>
                        <td> {rec.MHL_SR_Type__c} </td>
                        <td> {rec.MHL_SRSubType__c} </td>
                        <td> {rec.Status} </td>
                        <td> {rec.Subject} </td>
                        <td> {rec.MHL_Department__c} </td>
                        <td> {rec.Owner.Name} </td>

                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="10" className="text-center" > No Complaint found </td></tr >
                  )}
              </tbody>
            </table>
          </div>

          {
            filteredComplaintList.length > itemsPerPage ? (
              <div className="d-flex justify-content-center" style={{ marginTop: "30px" }}>
                <nav>
                  <ul className="pagination">
                    <li className="page-item">
                      <button
                        style={{ color: 'green' }}
                        className="page-link"
                        onClick={() => setCurrentPage(1)}
                      >
                        First
                      </button>
                    </li>

                    {(() => {
                      const totalPages = Math.ceil(filteredComplaintList.length / itemsPerPage);
                      const maxPagesToShow = 5;
                      let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
                      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

                      if (endPage - startPage + 1 < maxPagesToShow) {
                        startPage = Math.max(1, endPage - maxPagesToShow + 1);
                      }

                      return [...Array(endPage - startPage + 1)].map((_, index) => (
                        <li key={index} style={{ color: 'green' }} className="page-item">
                          <button
                            style={{
                              color: 'green',
                              border: currentPage === startPage + index ? '2px solid green' : '2px solid #ccc',
                              backgroundColor: currentPage === startPage + index ? '#e6ffe6' : 'transparent',
                              borderRadius: '0',
                              padding: '5px 10px',
                              cursor: 'pointer',
                              zIndex: currentPage === startPage + index ? '2' : '1',
                              position: 'relative',
                            }}
                            className="page-link"
                            onClick={() => setCurrentPage(startPage + index)}
                          >
                            {startPage + index}
                          </button>
                        </li>
                      ));
                    })()}

                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage(Math.ceil(filteredComplaintList.length / itemsPerPage))
                        }
                        style={{ color: 'green' }}
                      >
                        Last
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>

            ) : null}

        </div>

        {
          caseDetailModal && selectedCase && (
            <>
              {/* <div className="case-details-container" style={{maxHeight: "500px" }} > */}
              <div className="modal-backdrop" > </div>
              < div className="modal fade show d-block " tabIndex="-1" role="dialog" >
                <div className="modal-dialog modal-lg custom-modal" role="document" >
                  <div className="modal-content mb-0 p-0" >

                    <div className="modal-header  p-2-5" >
                      <h5 className="modal-title" > <b>Case Information </b> ({selectedCase.CaseNumber}/{selectedCase.Status}{selectedCase.MHL_Case_Stage__c ? "/" + selectedCase.MHL_Case_Stage__c : ""})</h5>
                      < button type="button" disabled={loading} className="btn-close" onClick={handleCloseCaseDetail} > </button>
                    </div>

                    <div className="modal-body p-1" style={{ fontSize: "14px", height: "68vh", overflowY: "auto" }}>
                      <LoadingSpinnerComponent></LoadingSpinnerComponent>
                      <ul className="nav nav-tabs mb-2" >
                        <li className="nav-item" >
                          <button
                            type="button"
                            className={`tab-button-header nav-link ${caseViewActiveTab === "caseDetails" ? "active highlighted-tab" : ""}`}
                            onClick={() => setCaseViewActiveTab("caseDetails")}
                          >
                            Details
                          </button>
                        </li>
                        {(selectedCase.MHL_SR_Type__c === "Refund") && (
                          <li className="nav-item">
                            <button
                              type="button"
                              className={`tab-button-header nav-link ${caseViewActiveTab === "o2cDetails" ? "active highlighted-tab" : ""}`}
                              onClick={() => setCaseViewActiveTab("o2cDetails")}
                            >
                              O2C Details
                            </button>
                          </li>
                        )}

                        < li className="nav-item" >
                          <button
                            type="button"
                            className={`tab-button-header nav-link ${caseViewActiveTab === "attachmentDetails " ? "active highlighted-tab" : ""}`}
                            onClick={() => {
                              GetAttachmentsByCaseId(selectedCase.Id)
                              setCaseViewActiveTab("attachmentDetails")
                            }}
                          >
                            Attachment
                          </button>
                        </li>
                        < li className="nav-item" >
                          <button
                            type="button"
                            style={{ color: "black" }}
                            className={`tab-button-header nav-link ${caseViewActiveTab === "comments" ? "active highlighted-tab" : ""}`}
                            onClick={() => {
                              GetCaseCommentByCaseId(selectedCase.Id)
                              setCaseViewActiveTab("comments");
                            }
                            }>
                            Case Comments
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            type="button"
                            className={`tab-button-header nav-link ${caseViewActiveTab === "caseHistory" ? "active highlighted-tab" : ""}`}
                            onClick={() => {
                              GetCaseHistoryByCaseId(selectedCase.Id);
                              setCaseViewActiveTab("caseHistory");
                            }}
                          >
                            Case History
                          </button>
                        </li>
                      </ul>

                      {caseViewActiveTab === "caseDetails" && (
                        <>
                          <div className="section" >
                            <div className="section-header" >
                              <span>Case Details </span>
                              < i className={`toggle-icon d-flex`
                              } onClick={() => toggleSection("caseDetails")}>
                                {expandedSections.caseDetails ? <FaMinusSquare /> : <FaPlusSquare />}
                              </i>
                            </div>
                            {
                              expandedSections.caseDetails && (
                                <form onSubmit={handleEditCaseSubmit(UpdateCaseDetail)}>
                                  <div className="section-content" style={{ fontSize: "13px" }}>
                                    <div className="row">
                                      <div className="col-md-6">
                                        <p className="case-details">
                                          <strong>Case Origin:</strong> <span>{selectedCase.Origin}</span>
                                          <input type="hidden" {...registerEditCase("Id")} value={selectedCase.Id} />
                                          {/* <input type="hidden" {...registerEditCase("CaseNumber")} value={selectedCase.CaseNumber} /> */}
                                        </p>
                                        <p className="case-details">
                                          <input type="hidden" {...registerEditCase("MHL_Call_Type__c")} value={selectedCase.MHL_Call_Type__c} />
                                          <input type="hidden" {...registerEditCase("RecordTypeId")} value={selectedCase.RecordTypeId} />
                                          <strong>Call Type:</strong> <span>{selectedCase.MHL_Call_Type__c}</span>
                                        </p>

                                        <div className="case-selection">
                                          <label className="case-label"> <strong>Case Raised &nbsp;For:</strong></label>
                                          <div className="case-select-wrapper">
                                            <select className="form-select case-dropdown" defaultValue={selectedCase?.MHL_Case_Raised_Against__c || ""}
                                              {...registerEditCase("MHL_Case_Raised_Against__c", { required: "Case Raised For is required" })} onChange={handleEditDependedTagsofCaseRaised} >
                                              <option className="dropdown-option" value="">Select Case Raised For</option>
                                              {CaseCategoryDetailsList.map((item) => (
                                                <option className="dropdown-option" key={item.CaseCategory_Id} value={item.CaseCategory} data-edit-casecategoryid={item.CaseCategory_Id}>
                                                  {item.CaseCategory}
                                                </option>
                                              ))}
                                            </select>
                                            {errorEditCase.MHL_Case_Raised_Against__c && (<p className="text-danger required_error"> {errorEditCase.MHL_Case_Raised_Against__c.message} </p>
                                            )}
                                          </div>
                                        </div>
                                        <div className="case-selection">
                                          <label className="case-label"><strong>SR Location:</strong></label>
                                          <div className="case-select-wrapper">
                                            <select className="form-select case-dropdown" defaultValue={selectedCase?.MHL_Location__c || ""} {...registerEditCase("MHL_Location__c", { required: "Location is required" })}>
                                              <option className="dropdown-option" value="">Select Location</option>
                                              {CaseLocationDetailsList.map((item) => (
                                                <option className="dropdown-option" key={item.CaseLocation_Id} value={item.LocationName}>{item.LocationName}</option>
                                              ))}
                                            </select>
                                            {errorEditCase.MHL_Location__c && (<p className="text-danger required_error">{errorEditCase.MHL_Location__c.message}</p>)}
                                          </div>
                                        </div>
                                        {/* <p className="case-selection">
                                          <strong className="case-label">SR Location:</strong>
                                          <select className="form-select case-dropdown" defaultValue={selectedCase?.MHL_Location__c || ""} {...registerEditCase("MHL_Location__c", { required: "Location is required" })} >
                                            <option value="">Select Location</option>
                                            {CaseLocationDetailsList.map((item) => (
                                              <option key={item.CaseLocation_Id} value={item.LocationName}>
                                                {item.LocationName}
                                              </option>
                                            ))}
                                          </select>
                                          {errorEditCase.MHL_Location__c && <p className="text-danger required_error">{errorEditCase.MHL_Location__c.message}</p>}
                                        </p> */}

                                        {/* <p className="case-selection">
                                          <strong>Case Raised For:</strong>
                                          <select
                                            className="form-select case-dropdown"
                                            defaultValue={selectedCase?.MHL_Case_Raised_Against__c || ""}
                                            {...registerEditCase("MHL_Case_Raised_Against__c", { required: "Case Raised For is required" })}
                                            onChange={handleEditDependedTagsofCaseRaised}
                                          >
                                            <option value="">Select SR Sub Type</option>

                                            {CaseCategoryDetailsList.map((item) => (
                                              <option key={item.CaseCategory_Id} value={item.SFDC_Category_Name} data-edit-casecategoryid={item.CaseCategory_Id}>
                                                {item.CaseCategory}
                                              </option>
                                            ))}
                                          </select>
                                          {errorEditCase.MHL_Case_Raised_Against__c && <p className="text-danger required_error">{errorEditCase.MHL_Case_Raised_Against__c.message}</p>}
                                        </p> */}

                                        <p className="case-details">
                                          <strong>Department:</strong> <span>{selectedCase.MHL_Department__c}</span>
                                        </p>
                                        <p className="case-details">
                                          <strong>Subject:</strong> <span>{selectedCase.Subject}</span>
                                        </p>
                                        <p className="case-details flex-column align-items-start">
                                          <strong>Description:</strong>
                                          {selectedCase.Description && (
                                            <span>
                                              {showFullDescription ? selectedCase.Description : `${selectedCase.Description.slice(0, 70)}...`}
                                              {selectedCase.Description.length > 70 && (
                                                <span
                                                  onClick={() => setShowFullDescription(!showFullDescription)}
                                                  style={{ fontSize: "12px", color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                                >
                                                  {showFullDescription ? "See less" : "See more"}
                                                </span>
                                              )}
                                            </span>
                                          )}
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p className="case-details">
                                          <strong>Case Owner:</strong> <span>{selectedCase.Owner.Name}</span>
                                        </p>
                                        <p className="case-details">
                                          <strong>Record Type:</strong> <span>{selectedCase.RecordType.Name}</span>
                                        </p>
                                        <div className="case-selection">
                                          <label className="case-label"><strong>SR Type:</strong></label>
                                          <div className="case-select-wrapper">
                                            <select className="form-select case-dropdown" defaultValue={selectedCase?.MHL_SR_Type__c || ""} {...registerEditCase("MHL_SR_Type__c", { required: "SR Type is required" })} onChange={handleEditSRTypeChange}>
                                              <option  className="dropdown-option" value="">Select SR Type</option>
                                              {CaseSRTypeDetailsList.map((item) => (
                                                <option className="dropdown-option" key={item.CaseSRType_Id} value={item.TypeName} data-edit-srtypeid={item.CaseSRType_Id}>{item.TypeName}</option>
                                              ))}
                                            </select>
                                            {errorEditCase.MHL_SR_Type__c && (<p className="text-danger required_error">{errorEditCase.MHL_SR_Type__c.message}</p>)}
                                          </div>
                                        </div>

                                        <div className="case-selection">
                                          <label className="case-label"><strong>SR Sub Type:</strong></label>
                                          <div className="case-select-wrapper">
                                            <select className="form-select case-dropdown" defaultValue={selectedCase?.MHL_SRSubType__c || ""} {...registerEditCase("MHL_SRSubType__c", { required: "SR Sub Type is required" })}>
                                              <option className="dropdown-option" value="">Select SR Sub Type</option>
                                              {CaseSRSubTypeDetailsList.map((item) => (
                                                <option className="dropdown-option" key={item.SubTypeNameId} value={item.SubTypeName}>{item.SubTypeName}</option>
                                              ))}
                                            </select>
                                            {errorEditCase.MHL_SRSubType__c && (<p className="text-danger required_error">{errorEditCase.MHL_SRSubType__c.message}</p>)}
                                          </div>
                                        </div>

                                        <div className="case-selection">
                                          <label className="case-label"><strong>Case Stage:</strong></label>
                                          <div className="case-select-wrapper">
                                            <select className="form-select case-dropdown" defaultValue={selectedCase?.MHL_Case_Stage__c || ""} {...registerEditCase("MHL_Case_Stage__c")}>
                                              <option className="dropdown-option" value="">Select Case Stage</option>
                                              {CaseStageDetailsList.map((item) => (
                                                <option className="dropdown-option" key={item.CaseStage_Id} value={item.CaseStage}>{item.CaseStage}</option>
                                              ))}
                                            </select>
                                          </div>
                                        </div>

                                        <p className="case-details">
                                          <strong>Test Name:</strong> <span>{selectedCase.External_Test_Name__c}</span>
                                        </p>
                                        <p className="case-details">
                                          <strong>Type Of Case:</strong> <span>{selectedCase.MHL_Type_of_Case__c}</span>
                                        </p>
                                        <p className="case-details">
                                          <strong>Country:</strong> <span>{selectedCase.MHL_Country__c}</span>
                                        </p>
                                      </div>
                                    </div>
                                    {selectedCase.Status === "Open" && (
                                      <div style={{ textAlign: "right" }}>
                                        <button type="submit" disabled={loading} className="btn btn-primary">Update Case</button>
                                      </div>
                                    )}
                                    {/* <button type="submit" className="btn btn-primary">Update</button> */}
                                  </div>
                                </form>
                              )}
                          </div>

                          {/* Customer Details Section */}
                          <div className="section" style={{ fontSize: "13px" }} >
                            <div className="section-header" >
                              <span>Customer Details </span>
                              < i className={`toggle-icon d-flex`} onClick={() => toggleSection("customerDetails")}>
                                {expandedSections.customerDetails ? <FaMinusSquare /> : <FaPlusSquare />}
                              </i>
                            </div>
                            {
                              expandedSections.customerDetails && (
                                <div className="section-content" >
                                  <div className="row" >
                                    <div className="col-md-6" >
                                      <p className="case-details"><strong>Customer PID: </strong> {selectedCase.MHL_Customer_PID__c}</p >
                                      <p className="case-details"><strong>Customer VID: </strong> {selectedCase.MHL_Customer_VID__c}</p >
                                      <p className="case-details"><strong>Location: </strong> {selectedCase.MHL_Locations__c}</p >
                                    </div>
                                    < div className="col-md-6" >
                                      <p className="case-details"><strong>Customer Name: </strong> {selectedCase.MHL_Customer_Name__c}</p >
                                      <p className="case-details"><strong>Customer Email: </strong> {selectedCase.MHL_Customer_Email__c}</p >
                                      <p className="case-details"><strong>Customer Mobile: </strong>{selectedCase.MHL_Customer_Mobile__c}</p >
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          </div>

                          {/* Status Section */}
                          <div className="section" style={{ fontSize: "13px" }} >
                            <div className="section-header" >
                              <span>Status </span>
                              < i className={`toggle-icon d-flex`} onClick={() => toggleSection("status")}>
                                {expandedSections.status ? <FaMinusSquare /> : <FaPlusSquare />}
                              </i>
                            </div>
                            {
                              expandedSections.status && (
                                <div className="section-content" >
                                  <div className="row" >
                                    <div className="col-md-6" >
                                      <p className="case-details"><strong>Status: </strong> {selectedCase.Status}</p >
                                      <p className="case-details"><strong>Cancellation Reason: </strong> {selectedCase.MHL_Cancellation_Reason__c}</p >
                                      <p className="case-details"><strong>Case Age Diff: </strong> {selectedCase.MHL_caseAgeDiff__c}</p >
                                    </div>
                                    < div className="col-md-6" >
                                      <p className="case-details"><strong>Priority: </strong> {selectedCase.Priority}</p >

                                      <p className="case-details"><strong>Date / Time Opened: </strong> {moment(selectedCase.CreatedDate).format("DD-MMM-YYYY hh:mm A")}</p >
                                      <p className="case-details">
                                        <strong>Date / Time Closed: </strong>
                                        {selectedCase.MHL_Closed_Date_Time__c ? moment(selectedCase.MHL_Closed_Date_Time__c).format("DD-MMM-YYYY hh:mm A") : "NA"}
                                      </p>                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          </div>

                          {/* Action Taken Section */}
                          <div className="section" style={{ fontSize: "13px" }} >
                            <div className="section-header" >
                              <span>Action Taken </span>
                              < i className={`toggle-icon d-flex`} onClick={() => toggleSection("actionTaken")}>
                                {expandedSections.actionTaken ? <FaMinusSquare /> : <FaPlusSquare />}
                              </i>
                            </div>
                            {
                              expandedSections.actionTaken && (
                                <div className="section-content" >
                                  <div className="row" >
                                    <div className="col-md-6" >
                                      <p className="case-details"><strong>Resolutions: </strong> {selectedCase.MHL_Resolutions__c}</p>
                                      <p className="case-details"><strong>Resolution Channel: </strong> {selectedCase.MHL_Resolution_Channel__c}</p>
                                    </div>
                                    < div className="col-md-6" >
                                      <p className="case-details"><strong>Internal Comments: </strong> {selectedCase.Comments}</p>
                                      <p className="case-details"><strong>Staff Responsible: </strong> {selectedCase.MHL_Staff_Responsible__c}</p>
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        </>
                      )}

                      {caseViewActiveTab === "o2cDetails" && (
                        <div className="container" style={{ fontSize: "13px" }}>
                          {/* <h5><b>O2C Details</b></h5> */}
                          <div className="row" >
                            <div className="col-md-6">
                              <p className="case-details"><strong>Payment Received:</strong> INR {selectedCase.MHL_PaymentReceived__c}</p>
                              <p className="case-details"><strong>Payment Received Amount:</strong> INR {selectedCase.MHL_PaymentReceivedAmount__c}</p>
                              <p className="case-details"><strong>Amount To Be Refunded:</strong> INR {selectedCase.MHL_Amount_To_Be_Refunded__c}</p>
                            </div>
                            <div className="col-md-6">
                              {/* <p className="case-details"><strong>Payment Received Date:</strong> {moment(selectedCase.MHL_Payment_Received_Date__c).format("DD-MMM-YYYY hh:mm A")}</p> */}
                              <p className="case-details">
                                <strong>Payment Received Date: </strong>
                                {selectedCase.MHL_Payment_Received_Date__c ? moment(selectedCase.MHL_Payment_Received_Date__c).format("DD-MMM-YYYY hh:mm A") : "NA"}
                              </p>
                              {/* <p className="case-details"><strong>Payment Received Date:</strong> {moment(selectedCase.MHL_Payment_Received_Date__c).format("DD-MMM-YYYY hh:mm A")}</p> */}
                              <p className="case-details"><strong>Payment Mode:</strong> {selectedCase.MHL_PaymentMode__c}</p>
                              <p className="case-details"><strong>CC Avenue No./Payment Reference No. :</strong>  {selectedCase.MHL_CC_Avenue_No_Payment_Reference_No__c}</p>
                            </div>
                          </div>
                        </div>
                      )}

                      {
                        caseViewActiveTab === "attachmentDetails" && (
                          <div>
                            <div className="container" >
                              <ul className="list-group" >
                                {caseAttachmentDetails && caseAttachmentDetails.length > 0 ? (
                                  caseAttachmentDetails.map((file) => (
                                    <li key={file.ContentDocumentId} className="list-group-item d-flex align-items-center" >
                                      {FileIcons[file.FileExtension] || FileIcons.other}
                                      {file.Title}
                                      < span className="badge bg-light ms-auto p-2 rounded" >
                                        <FaDownload disabled={loading} onClick={() => handleDownloadAttachment(file)} style={{ color: 'green', fontSize: '18px' }} />
                                      </span>

                                    </li>
                                  ))
                                ) : (
                                  // <li className="list-group-item text-muted" > No attachments available </li>
                                  <p> No attachments available... </p>
                                )}
                              </ul>

                            </div>
                          </div>
                        )}

                      {
                        caseViewActiveTab === "comments" && (
                          <div className="p-2">
                            <div className="table-responsive" >
                              <table className="table table-hover table-striped" >
                                <thead>
                                  <tr>
                                    < th className="user-column"> User </th>
                                    < th className="date-column"> Created Date </th>
                                    < th className="comment-column" > Comment </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    caseCommentDetails && caseCommentDetails.length > 0 ? (
                                      caseCommentDetails.map((dt, index) => (
                                        <tr key={dt.Id || index} >
                                          < td > {dt.CreatedBy.Name} </td>
                                          < td > {moment(dt.CreatedDate).format("DD-MMM-YYYY hh:mm A")} </td>
                                          < td > {dt.CommentBody} </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="7" className="text-center" >
                                          No comments found
                                        </td>
                                      </tr>
                                    )
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}

                      {caseViewActiveTab === "caseHistory" && (
                        <div className="p-2">
                          <div className="table-responsive">
                            <table className="table table-hover table-striped">
                              <thead>
                                <tr>
                                  <th >Date</th>
                                  <th >Field</th>
                                  <th >User</th>
                                  <th className="user-column">Original Value</th>
                                  <th className="user-column">Old Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                {caseHistoryDetails && caseHistoryDetails.length > 0 ? (
                                  caseHistoryDetails.map((dt, index) => (
                                    <tr key={dt.Id || index}>
                                      <td>{moment(dt.CreatedDate).format("DD-MMM-YYYY hh:mm A")}</td>
                                      <td>{dt.Field}</td>
                                      <td>{dt.CreatedBy.Name}</td>
                                      <td>{dt.NewValue}</td>
                                      <td>{dt.OldValue}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="5" className="text-center">
                                      No history found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}

                    </div>

                    < div className="modal-footer" >
                      <button type="button" disabled={loading} className="btn btn-danger" onClick={handleCloseCaseDetail} >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}

            </>
          )}


        {complaintTypeShow && (
          <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-sm custom-modal-com" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">New Case</h5>
                    <button type="button" disabled={loading} className="btn-close" onClick={handleComplaintTypeClose}></button>
                  </div>
                  <div className="modal-body">
                    <div>
                      <label className="fw-bold required mb-0-5" > Select a Record Type </label>
                      {CaseRecordTypeDetialList.map((type) => (
                        <div key={type.RecordTypeId} className="form-check">
                          <input
                            type="radio"
                            id={type.RecordTypeId}
                            className="form-check-input form-check-newcase"
                            value={type.RecordTypeId}
                            checked={selectedComplaintType === type.RecordType}
                            onChange={() => { setSelectedComplaintType(type.RecordType); setSelectedComplaintTypeID(type.RecordTypeId) }}
                          />
                          <label htmlFor={type.RecordTypeId} className="form-check-label">{type.RecordType}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" disabled={loading} className="btn btn-danger" onClick={handleComplaintTypeClose}>Close</button>
                    <button type="button" disabled={loading} className="btn btn-primary" onClick={handleProceed}>Proceed</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* New Case Popup */}
        {newComplaintShow && (
          <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-lg custom-modal" role="document">
                <div className="modal-content mb-0 p-0">
                  <div className="modal-header p-2-5">
                    <h5 className="modal-title">New Case: {selectedComplaintType}</h5>
                    <button type="button" disabled={loading} className="btn-close" onClick={handleNewComplaintClose}></button>
                  </div>
                  <div className="modal-body p-1">
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                      <ul className="nav nav-tabs mb-2">
                        <li className="nav-item">
                          <button type="button" className={`tab-button-header nav-link ${activeTab === "caseDetails" ? "active highlighted-tab" : ""} `} onClick={() => setActiveTab("caseDetails")}>Case Information</button>
                        </li>
                        {showAdditionalRefundInfo && (
                          <li className="nav-item">
                            <button type="button" className={`tab-button-header nav-link ${activeTab === "additionalRefundInfo" ? "active highlighted-tab" : ""}`} onClick={() => setActiveTab("additionalRefundInfo")}>
                              Additional Info
                            </button>
                          </li>)}
                        <li className="nav-item">
                          <button type="button" className={`tab-button-header nav-link ${activeTab === "addAttachments" ? "active highlighted-tab" : ""}`} onClick={() => setActiveTab("addAttachments")}>
                            Add Attachments
                          </button>
                        </li>
                        <li className="nav-item">
                          <button type="button" className={`tab-button-header  nav-link ${activeTab === "customerDetails" ? "active highlighted-tab" : ""}`} onClick={() => setActiveTab("customerDetails")}>Customer Details</button>
                        </li>
                      </ul>
                      {/* <ul className="nav nav-tabs mb-2">
                        <li className="nav-item"><button type="button" className={`tab-button-header nav-link ${activeTab === "caseDetails" ? "active" : ""}`} onClick={() => handleTabClick("caseDetails")}>Case Information</button></li>
                        {showAdditionalRefundInfo && <li className="nav-item"><button type="button" className={`tab-button-header nav-link ${activeTab === "additionalRefundInfo" ? "active" : ""}`} onClick={() => handleTabClick("additionalRefundInfo")}>Additional Info</button></li>}
                        <li className="nav-item"><button type="button" className={`tab-button-header nav-link ${activeTab === "addAttachments" ? "active" : ""}`} onClick={() => handleTabClick("addAttachments")}>Add Attachments</button></li>
                        <li className="nav-item"><button type="button" className={`tab-button-header nav-link ${activeTab === "customerDetails" ? "active" : ""}`} onClick={() => handleTabClick("customerDetails")}>Customer Details</button></li>
                      </ul> */}

                      {activeTab === "caseDetails" && (
                        <div className="container mb-0 " style={{ fontSize: "13px" }}>

                          <div className="row mb-1">
                            <div className="col-md-4 mb-1">
                              <label className="fw-bold required mb-0-5">Case Origin</label>
                              <select className="form-select " {...register("Origin", { required: "Case Origin is required" })}>

                                <option value="">Select Case Origin</option>
                                {CaseOriginDetailList.map((item) => (
                                  <option key={item.CaseOriginId} value={item.CaseOrigin}>
                                    {item.CaseOrigin}
                                  </option>
                                ))}
                              </select>
                              {errors.Origin && <p className="text-danger required_error">{errors.Origin.message}</p>}
                            </div>

                            < div className="col-md-4 mb-1" >
                              <label className="fw-bold required mb-0-5" > Case Record Type </label>
                              < input type="text" className="form-control" value={selectedComplaintType} readOnly {...register("CaseRecordType", { required: "Case Record Type is required" })} />
                              < input type="text" className="form-control" value={SelectedComplaintTypeID} hidden {...register("RecordTypeId")} />
                              {errors.CaseRecordType && <p className="text-danger required_error" > {errors.CaseRecordType.message} </p>}
                            </div>

                            <div className="col-md-4 mb-1">
                              <label className="fw-bold required mb-0-5">Call Type</label>
                              <select className="form-select" {...register("Call_Type", { required: "Call Type is required" })}
                                onChange={handleCallTypeSetCaseRaised}>
                                <option value="">Select Call Type</option>
                                {CaseTypeDetailList.map((item) => (
                                  <option key={item.CallTypeId} value={item.CallType} data-calltypeid={item.CallTypeId}>
                                    {item.CallType}
                                  </option>
                                ))}
                              </select>
                              {errors.Call_Type && <p className="text-danger required_error">{errors.Call_Type.message}</p>}
                            </div>
                          </div>

                          <div className="row" >
                            <div className="col-md-4 mb-1" >
                              <label className="fw-bold required mb-0-5" > Case Raised For </label>
                              <select className="form-select" {...register("Case_Raised_Against", { required: "Case Raised For is required" })} onChange={handleDependedTagsofCaseRaised}>
                                <option value="">Select Case Raised </option>
                                {CaseCategoryDetailsList.map((item) => (
                                  <option key={item.CaseCategory_Id} value={item.SFDC_Category_Name} data-casecategoryid={item.CaseCategory_Id}>
                                    {item.CaseCategory}
                                  </option>
                                ))}
                              </select>
                              {errors.Case_Raised_Against && <p className="text-danger required_error" > {errors.Case_Raised_Against.message} </p>}
                            </div>

                            <div className="col-md-4 mb-1" >
                              <label className="fw-bold required mb-0-5" >SR Type</label>
                              <select className="form-select " {...register("SR_Type", { required: "SR Type is required" })} onChange={handleSRTypeChange}>
                                <option value="">Select SR Type</option>
                                {CaseSRTypeDetailsList.map((item) => (
                                  <option key={item.CaseSRType_Id} value={item.TypeName} data-srtypeid={item.CaseSRType_Id}>
                                    {item.TypeName}
                                  </option>
                                ))}
                              </select>
                              {errors.SR_Type && <p className="text-danger required_error" > {errors.SR_Type.message} </p>}
                            </div>
                            <div className="col-md-4 mb-1" >
                              <label className="fw-bold required mb-0-5 required" > SR Sub Type </label>
                              <select className="form-select " {...register("SR_SubType", { required: "SR Sub Type is required" })}>
                                <option value="">Select SR Sub Type</option>
                                {CaseSRSubTypeDetailsList.map((item) => (
                                  <option key={item.SubTypeNameId} value={item.SubTypeName}>
                                    {item.SubTypeName}
                                  </option>
                                ))}
                              </select>
                              {errors.SR_SubType && <p className="text-danger required_error" > {errors.SR_SubType.message} </p>}
                            </div>

                          </div>

                          <div className="row" >
                            < div className="col-md-4 mb-1" >
                              <label className="fw-bold required mb-0-5" > Location </label>
                              <select className="form-select " {...register("Location", { required: "Location is required" })}>
                                <option value="">Select Location</option>
                                {CaseLocationDetailsList.map((item) => (
                                  <option key={item.CaseLocation_Id} value={item.LocationName}>
                                    {item.LocationName}
                                  </option>
                                ))}
                              </select>
                              {errors.Location && <p className="text-danger required_error" > {errors.Location.message} </p>}
                            </div>

                            <div className="col-md-4 mb-1" >
                              <label className="fw-bold mb-0-5" > Case Stage </label>
                              <select className="form-select " {...register("Case_Stage")}>
                                <option value="">Select Case Stage</option>
                                {CaseStageDetailsList.map((item) => (
                                  <option key={item.CaseStage_Id} value={item.CaseStage}>
                                    {item.CaseStage}
                                  </option>
                                ))}
                              </select>
                              {errors.Case_Stage && <p className="text-danger required_error" > {errors.Case_Stage.message} </p>}
                            </div>

                            <div className="col-md-4 mb-1" >
                              <label className="fw-bold  mb-0-5" > Country </label>
                              <select className="form-select " {...register("Country")}>
                                <option value="">Select Country</option>
                                {CountryDetailList.map((item) => (
                                  <option key={item.CountryId} value={item.CountryName}>
                                    {item.CountryName}
                                  </option>
                                ))}
                              </select>
                            </div>

                          </div>


                          < div className="row" >
                            <div className="col-md-4 mb-1" >
                              <label className="fw-bold mb-0-5" > Test Name </label>
                              < input type="text" className="form-control" {...register("Test_Name")} />
                            </div>
                            < div className="col-md-4 mb-1" >
                              <label className="fw-bold required mb-0-5" > Subject </label>
                              < input type="text" className="form-control" {...register("Subject", { required: "Subject is required" })} />
                              {errors.Subject && <p className="text-danger required_error" > {errors.Subject.message} </p>}
                            </div>
                            < div className="col-md-4 mb-1" >
                              <label className="fw-bold mb-0-5" > Type Of Case </label>
                              <select className="form-select " {...register("Type_of_Case")}>
                                <option value="">Select Type Of Case</option>
                                {TYPE_Of_CASE.map((item) => (
                                  <option key={item.key} value={item.key}>
                                    {item.value}
                                  </option>
                                ))}
                              </select>
                              {errors.Type_of_Case && <p className="text-danger required_error" > {errors.Type_of_Case.message} </p>}
                            </div>

                          </div>

                          <div className="row" >
                            <div className="col-md-12 mb-1" >
                              <label className="fw-bold required mb-0-5" > Description </label>
                              <textarea type="text" rows={3} className="form-control" {...register("Description", { required: "Description is required" })} />
                              {errors.Description && <p className="text-danger required_error" > {errors.Description.message} </p>}
                            </div>
                          </div>
                        </div>

                      )}

                      {activeTab === "customerDetails" && (
                        <div className="container" style={{ fontSize: "13px" }}>
                          <div className="row" >

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5" htmlFor="Customer_PID">Customer PID</label>
                              <input
                                id="Customer_PID"
                                type="text"
                                className="form-control"
                                {...register("Customer_PID", {
                                  required: "Customer PID is required",
                                  maxLength: { value: 18, message: "Maximum 18 characters allowed" },
                                  minLength: { value: 15, message: "Minimum 15 characters allowed" },
                                })}
                              />
                              {errors.Customer_PID && errors.Customer_PID.message && (
                                <p className="text-danger required_error">{errors.Customer_PID.message}</p>
                              )}
                            </div>

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5" htmlFor="Customer_VID">Customer VID</label>
                              <input
                                id="Customer_VID"
                                type="text"
                                className="form-control"
                                {...register("Customer_VID", {
                                  required: "Customer VID is required",
                                  maxLength: { value: 18, message: "Maximum 18 characters allowed" },
                                  minLength: { value: 15, message: "Minimum 15 characters allowed" },
                                })}
                              />
                              {errors.Customer_VID && errors.Customer_VID.message && (
                                <p className="text-danger required_error">{errors.Customer_VID.message}</p>
                              )}
                            </div>

                            < div className="col-md-4 mb-2" >
                              <label className="fw-bold required mb-0-5" > Customer Name </label>
                              < input type="text" className="form-control" {...register("Customer_Name", {
                                required: "Customer Name is required",
                                maxLength: { value: 50, message: "Maximum 50 characters allowed" }
                              })} />
                              {errors.Customer_Name && <p className="text-danger required_error" > {errors.Customer_Name.message} </p>}
                            </div>
                          </div>

                          < div className="row" >
                            <div className="col-md-4 mb-2" >
                              <label className="fw-bold required mb-0-5" > Customer Email </label>
                              < input type="email" className="form-control"
                                {...register("Customer_Email", {
                                  required: "Customer Email is required",
                                  pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Invalid email address",
                                  },
                                })} />
                              {/* // {...register("Customer_Email", { required: "Customer Email is required" })} /> */}
                              {errors.Customer_Email && <p className="text-danger required_error" > {errors.Customer_Email.message} </p>}
                            </div>
                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Customer Mobile</label>
                              <input type="text" className="form-control"  {...register("Customer_Mobile", {
                                required: "Customer Mobile is required", pattern: { value: /^[0-9]+$/, message: "Only numbers are allowed", },
                                minLength: { value: 10, message: "Mobile number must be at least 10 digits", },
                                maxLength: { value: 10, message: "Mobile number must not exceed 10 digits", },
                              })}
                                onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))} />
                              {errors.Customer_Mobile && (
                                <p className="text-danger required_error">
                                  {errors.Customer_Mobile.message}
                                </p>
                              )}
                            </div>
                            <div className="col-md-4 mb-2" >
                              <label className="fw-bold required mb-0-5" > Location </label>
                              <input type="text" className="form-control" {...register("Locations", {
                                required: "Location is required",
                                maxLength: { value: 50, message: "Maximum 50 characters allowed" }
                              })} />
                              {errors.Locations && <p className="text-danger required_error" > {errors.Locations.message} </p>}
                            </div>
                          </div>

                        </div>
                      )}

                      {activeTab === "additionalRefundInfo" && showAdditionalRefundInfo && (
                        <div className="container" style={{ fontSize: "13px" }}>
                          <div className="row">

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Reference VID</label>
                              <div className="position-relative">
                                <input type="text" hidden {...register("Ref_VID")} />
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register("MHL_VID__c", {
                                    required: "VID is required",
                                    validate: (value) => {
                                      const isValid = PatientVisitIdList.some(
                                        (item) => item.MHL_ExternalVID__c === value
                                      );
                                      return isValid || "Invalid Reference VID";
                                    }
                                  })}
                                  onChange={GetPatientVisitDataList}
                                />
                                {ShowPatientVisitIdList && (
                                  <ul className="dropdown-list list-unstyled">
                                    {PatientVisitIdList.map((item) => (
                                      <li key={item.MHL_ExternalVID__c} onClick={() => handleSelect(item)}>
                                        {item.MHL_ExternalVID__c} ({item.MHL_Patient_Name})
                                      </li>
                                    ))}
                                  </ul>
                                )}
                                {errors.MHL_VID__c && (
                                  <p className="text-danger required_error">{errors.MHL_VID__c.message}</p>
                                )}
                              </div>
                            </div>
                            {/* <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Reference VID</label>
                              <select className="form-select" {...register("Ref_VID", { required: "Ref VID is required" })}>
                                <input type="text" className="form-control" />
                                {PatientVisitIdList.map((item) => <option key={item.key} value={item.Value}>{item.Value}</option>)}
                              </select>
                              {errors.Ref_VID && <p className="text-danger required_error">{errors.Ref_VID.message}</p>}
                            </div> */}
                            {/* <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Reference VID</label>
                              <input type="text" className="form-control" {...register("Ref_VID", { required: "VID is required" })} />
                              {errors.Ref_VID && <p className="text-danger required_error">{errors.Ref_VID.message}</p>}
                            </div> */}

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Beneficiary Name</label>
                              <input
                                type="text"
                                className="form-control"
                                {...register("BeneficiaryName", {
                                  required: "Beneficiary Name is required",
                                  maxLength: { value: 50, message: "Maximum 50 characters allowed" }
                                })}
                              />
                              {errors.BeneficiaryName && <p className="text-danger required_error">{errors.BeneficiaryName.message}</p>}
                            </div>


                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Booking Reference ID</label>
                              <input type="text" className="form-control" {...register("BookingReferenceID", { required: "Booking Reference ID is required" })} />
                              {errors.BookingReferenceID && <p className="text-danger required_error">{errors.BookingReferenceID.message}</p>}
                            </div>

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Payment Mode</label>
                              <select className="form-select" {...register("PaymentMode", { required: "Payment Mode is required" })}>
                                <option value="">Select Payment Mode</option>
                                {ActivePaymentModeList.map((item) => <option key={item.key} value={item.Value}>{item.Value}</option>)}
                              </select>
                              {errors.PaymentMode && <p className="text-danger required_error">{errors.PaymentMode.message}</p>}
                            </div>
                            <div className="col-md-4 mb-2">
                              <label className="fw-bold">Bank Name</label>
                              <input
                                type="text"
                                className="form-control"
                                {...register("BankName", {
                                  maxLength: { value: 50, message: "Maximum 50 characters allowed" }
                                })}
                              />
                              {errors.BankName && <p className="text-danger required_error">{errors.BankName.message}</p>}
                            </div>

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold mb-0-5">Bank Account No.</label>
                              <input
                                type="text"
                                className="form-control"
                                {...register("BankAccountNo", {
                                  pattern: {
                                    value: /^[0-9]{9,18}$/,
                                    message: "Bank Account No. must be 9 to 18 digits"
                                  }
                                })}
                              />
                              {errors.BankAccountNo && <p className="text-danger required_error">{errors.BankAccountNo.message}</p>}
                            </div>

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold mb-0-5">IFSC</label>
                              <input
                                type="text"
                                className="form-control"
                                {...register("IFSC", {
                                  pattern: {
                                    value: /^[A-Za-z]{4}[0-9]{7}$/,
                                    message: "IFSC must be 4 letters followed by 7 digits"
                                  }
                                })}
                              />
                              {errors.IFSC && <p className="text-danger required_error">{errors.IFSC.message}</p>}
                            </div>

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold">Payment Reference No.</label>
                              <input type="text" className="form-control" {...register("PaymentReferenceNo")} />
                            </div>
                            <div className="col-md-4 mb-2">
                              <label className="fw-bold">Refund Amount</label>
                              <input
                                type="text" // using "text" to validate input pattern strictly
                                className="form-control"
                                {...register("RefundAmount", {
                                  validate: (value) => {
                                    if (value === "") return true;
                                    // Allow only valid numeric or float values
                                    const numberPattern = /^-?\d+(\.\d+)?$/;
                                    return numberPattern.test(value) || "Refund Amount must be a valid number";
                                  },
                                })}
                              />
                              {errors?.RefundAmount && (
                                <p className="text-danger">{errors.RefundAmount.message}</p>
                              )}
                            </div>

                            <div className="col-md-12 mb-2">
                              <label className="fw-bold">Bank Address</label>
                              <input
                                type="text"
                                className="form-control"
                                {...register("BankAddress", {
                                  maxLength: { value: 250, message: "Maximum 250 characters allowed" }
                                })}
                              />
                              {errors.BankAddress && <p className="text-danger required_error">{errors.BankAddress.message}</p>}
                            </div>

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Payment Date</label>
                              <input
                                type="date"
                                className="form-control"
                                {...register("PaymentDate", {
                                  required: "Payment Date is required",
                                  validate: (value) => {
                                    const selectedDate = new Date(value);
                                    const today = new Date();
                                    // Set time to 00:00 to compare only dates
                                    selectedDate.setHours(0, 0, 0, 0);
                                    today.setHours(0, 0, 0, 0);
                                    return selectedDate <= today || "Payment Date cannot be in the future";
                                  },
                                })}
                              />
                              {errors.PaymentDate && (
                                <p className="text-danger required_error">{errors.PaymentDate.message}</p>
                              )}
                            </div>

                            {/* <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Payment Date</label>
                              <input type="date" className="form-control" {...register("PaymentDate", { required: "Payment Date is required" })} />
                              {errors.PaymentDate && <p className="text-danger required_error">{errors.PaymentDate.message}</p>}
                            </div> */}

                            {/* <div className="col-md-4 mb-2">
                              <label className="fw-bold">UPI ID</label>
                              <input type="text" className="form-control" {...register("UPIID")} />
                            </div> */}

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold">UPI ID</label>
                              <input
                                type="text"
                                className="form-control"
                                {...register("UPIID", {
                                  validate: (value) => {
                                    if (value === "") return true;
                                    // Basic UPI ID format check: text@bank
                                    const upiPattern = /^[\w.-]+@[\w.-]+$/;
                                    return upiPattern.test(value) || "Invalid UPI ID format";
                                  },
                                })}
                              />
                              {errors?.UPIID && (
                                <p className="text-danger">{errors.UPIID.message}</p>
                              )}
                            </div>
                            <div className="col-md-4 mb-2">
                              <label className="fw-bold">Paid Amount</label>
                              <input
                                type="text" // using "text" to validate input pattern strictly
                                className="form-control"
                                {...register("PaidAmount", {
                                  validate: (value) => {
                                    if (value === "") return true;
                                    // Allow only valid numeric or float values
                                    const numberPattern = /^-?\d+(\.\d+)?$/;
                                    return numberPattern.test(value) || "Paid Amount must be a valid number";
                                  },
                                })}
                              />
                              {errors?.PaidAmount && (
                                <p className="text-danger">{errors.PaidAmount.message}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {activeTab === "addAttachments" && (

                        <div className="container" style={{ fontSize: "13px" }}>
                          <div className="d-flex flex-column flex-md-row align-items-center gap-2 mb-2 pl-3" style={{ fontSize: "13px" }} >
                            <label className="fw-bold mb-0-5">Upload Attachments :</label>
                            <input className="form-control" style={{ width: '250px' }} type="file"
                              // accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.webp,.bmp,.svg,.xlsx,.eml,.mp4,.mov"
                              ref={fileInputRef}
                              accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.webp,.bmp,.svg,.eml"
                              onChange={handleFileChange}
                            // disabled={selectedFiles.length >= maxFiles}
                            />
                            {/* {selectedFiles.length >= maxFiles && (
                              <small style={{ color: 'red' }}>Maximum {maxFiles} files selected.</small>
                            )} */}
                            {/* <p>Note : A</p> */}
                            <button className="btn custom-sumbitbtn" disabled={loading} type="button" onClick={handleFileUpload}> Upload </button>
                            {selectedFiles && selectedFiles.length > 0 && (
                              <button className="btn btn-danger" disabled={loading} type="button" onClick={handleRemoveSelectedUploadedFiles}> Remove </button>
                            )}
                            <div className="alert alert-info p-2 mt-1 pt-2" style={{ fontSize: '9px', maxWidth: '350px', marginBottom: '4px' }}>
                              <strong>Note:</strong> You can upload a maximum of 5 files(less than 5MB).<br />
                              Accepted file: <code>.pdf</code>, <code>.doc</code>, <code>.docx</code>, <code>.jpeg</code>, <code>.jpg</code>, <code>.png</code>, <code>.gif</code>, <code>.webp</code>, <code>.bmp</code>, <code>.svg</code>, <code>.eml</code>
                            </div>
                            {/* <div className="alert alert-info p-2 mt-1" style={{ fontSize: '10px', maxWidth: '400px' }}>
                              <strong>Note:</strong> Only the following file types are accepted: PDF, DOC, DOCX, image formats, EML, XLSX, MP4, and MOV. <br />
                              Maximum of 5 files allowed. Each file must be less than 5MB in size.
                            </div> */}
                          </div>

                          <ul className="list-group pl-3 pb-2 pt-1 col-md-6" >
                            {selectedFiles && selectedFiles.length > 0 ? (
                              selectedFiles.map((file) => (
                                <li key={file.ContentDocumentId} className="list-group-item d-flex align-items-center" >
                                  {FileIcons[file.name.split('.').pop()] || FileIcons.other}
                                  &nbsp;{file.name}
                                </li>
                              ))
                            ) : (
                              <p> No attachments available... </p>
                            )}
                          </ul>
                        </div>
                      )}

                      <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">

                        {/* <button type="button" disabled={loading} className="btn btn-danger" onClick={handleNewComplaintClose}> Close </button> */}
                        {activeTab !== "caseDetails" && (
                          <button type="button" disabled={loading} className="btn btn-secondary" onClick={handlePrevious}> Previous </button>
                        )}
                        <button type="submit" disabled={loading} className="btn btn-primary">
                          {activeTab === "customerDetails" ? "Save" : "Save & Next"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </CommonContainer>
    </>
  );
};

export default ComplaintListComponent;